/** @format */

import Vue from 'vue';
import Router from 'vue-router';

import auth from './auth';

import CsLogin from './components/cs-login';
import CsLogincallback from './components/cs-logincallback';
import CsNotfound from './components/cs-notfound';
import CsScreen from './global/cs-screen.vue';
import CsAnonymousAction from './components/cs-anonymous-action';

import $cs_ from '@/js/plugins/cs-underscore-helpers';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			name: 'root',
			path: '/',
			component: CsLogin
		},
		{
			name: 'logincallback',
			path: '/logincallback',
			component: CsLogincallback
		},
		{
			name: 'home',
			path: '/',
			component: CsScreen,
			meta: {requiresAuth: true},
			redirect: {
				name: 'csscreen',
				params: {
					entityorscreen: 'home'
				}
			}
		},
		{
			name: 'route404',
			path: '/404',
			component: CsNotfound
		},
		{
			name: 'anonymousAction',
			path: '/anonAction/:token/:formid/:buttonid',
			component: CsAnonymousAction
		},
		{
			name: 'csscreen',
			path: '/:entityorscreen/:screen?/:subscreen?',
			component: CsScreen,
			meta: {requiresAuth: true}
		},
		{
			name: 'notfound',
			path: '*',
			component: CsNotfound
		}
	],
	linkActiveClass: 'cs-fg-accent cs-router-link-exact-active'
});

//set a isProgrammaticNavigation with the push and replace methods and convert to no-op noError versions that will not throw
//Vue has a well known bug/feature where the catch block is not handle in their pus/replace calls
//Note only the pushNoError is currently used - see mi-routeControls
//https://github.com/vuejs/vue-router/issues/2963

let isProgrammaticNavigation = false;

router.programmaticPush = async function (...args) {
	isProgrammaticNavigation = true;	
	return router.push(...args).catch((error) => {
		isProgrammaticNavigation = false;			
	});
};

router.programmaticReplace = async function (...args) {
	isProgrammaticNavigation = true;	
	return router.replace(...args).catch((error) => {
		isProgrammaticNavigation = false;				
	});
};

router.beforeEach((to, from, next) => {
	// add the programmatic navigation attribute to the meta for the route,
	// this allows us to use it whenever we're watching the route for changes
	to.meta.isProgrammaticNavigation = isProgrammaticNavigation;

	//cancel navigation to the same route path when containing an empty query - this prevents the nav menu pushing a route when on the route
	let isEmptyQuery = to?.query == undefined || Object.keys(to.query).length === 0;
	if (from?.params?.screen != undefined && from.path === to.path && (isEmptyQuery && $cs_.isMatch(from.query, to.query) === true)) {
		isProgrammaticNavigation = false; // reset this to false
		return false;
	}

	if (to.matched.some((record) => record.meta.requiresAuth)) {
		auth.getUserManager()
			.getUser()
			.then((user) => {
				if (user) {
					next();
				} else {
					next({
						name: 'root',
						query: {redirect: to.fullPath}
					});
				}
			});
	} else {
		next();
	}
	isProgrammaticNavigation = false; // reset this to false
});

export default router;
